export class FormatUtility {
    public static formatHours(hours: number) : string {
        let result = "";

        if (hours >= 100.0) {
            result = hours.toFixed(0);
        }
        else if (hours >= 10.0) {
            result = hours.toFixed(1);
        }
        else if (hours >= 1.0) {
            result = hours.toFixed(2);
        } else {
            result = hours.toFixed(3);
            result = result.substring(1);
        }

        return result;
    }

    public static formatPrice(price?: any) : string {
        if (!price)
            return "-";

        return parseFloat(price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/utilities/formatUtility.ts